import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import vendorsSAService from "services/superadmin/vendorsSAService";
import AppSmartForm from "components/AppSmartForm/AppSmartForm";

const VendorForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { vendor },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
  ]

  const onSubmit = async (formValues) => {
    console.log("formValues: ", formValues);
    try {
      if (vendor) {
        await vendorsSAService.put(id, formValues)
        snack("Производитель обновлен успешно!");
      } else {
        await vendorsSAService.post(formValues)
        snack("Производитель создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={vendor ? 'Редактирование производителя' : 'Создание производителя'}>
      <AppSmartForm onSubmit={onSubmit} data={vendor} fields={fieldsWithData}></AppSmartForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(VendorForm, (router) => {
    let requests = {}

    if (router.params.id) {
      requests['vendor'] = () => vendorsSAService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
